module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_content",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('HeaderLine', {
    ref: "dialog",
    attrs: {
      "index": "13",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('devolop.name')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: " center "
  }, [_c('ul', {
    staticClass: "download_list main_wrap"
  }, [_c('li', {
    staticClass: "download_list_item"
  }, [_c('h3', {
    staticClass: "download_item_title"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title2')))]), _vm._v(" "), _c('h4', {
    staticClass: "download_item_title2"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title3')))]), _vm._v(" "), _c('ul', {
    staticClass: "download_platforms clearfix",
    staticStyle: {
      "padding-bottom": "0.7rem"
    }
  }, [_c('li', [_c('h3', {
    staticClass: "platform_name"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title4')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('devolop.version1')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.date1')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button1",
    attrs: {
      "href": "https://github.com/vrviu-sdk/BitPlayer-SDK-Unity/blob/master/README.md",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button1')))])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button2",
    attrs: {
      "href": "https://github.com/vrviu-sdk/BitPlayer-SDK-Unity",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button2')))])])]), _vm._v(" "), _c('li', [_c('h3', {
    staticClass: "platform_name"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title55')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('devolop.version2')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.date2')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button1",
    attrs: {
      "href": "https://github.com/vrviu-sdk/BitPlayer-SDK-Web/blob/master/README.md",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button1')))])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button2",
    attrs: {
      "href": "https://github.com/vrviu-sdk/BitPlayer-SDK-Web",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button2')))])])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "download_list main_wrap"
  }, [_c('li', {
    staticClass: "download_list_item"
  }, [_c('h3', {
    staticClass: "download_item_title"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title5')))]), _vm._v(" "), _c('h4', {
    staticClass: "download_item_title2"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title6')))]), _vm._v(" "), _c('ul', {
    staticClass: "download_platforms clearfix",
    staticStyle: {
      "padding-bottom": "1rem"
    }
  }, [_c('li', [_c('h3', {
    staticClass: "platform_name"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title7')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('devolop.version3')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.date3')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button1",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-iOS/blob/master/README.md",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button1')))])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button2",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-iOS",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button2')))])])]), _vm._v(" "), _c('li', [_c('h3', {
    staticClass: "platform_name"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title8')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('devolop.Version4')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.date4')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button1",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-Android/blob/master/README.md",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button1')))])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button2",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-Android",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button2')))])])]), _vm._v(" "), _c('li', [_c('h3', {
    staticClass: "platform_name"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title9')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('devolop.version5')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.date5')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button1",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-Web/blob/master/README.md",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button1')))])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button2",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-Web",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button2')))])])])])])])]), _vm._v(" "), _c('Footerline')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e43b73b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/devolop.vue
// module id = 85
// module chunks = 0